var map = {
	"./ALPHAROMEO.jpg": "./assets/images/vehicle/makes/ALPHAROMEO.jpg",
	"./APRILIA.jpg": "./assets/images/vehicle/makes/APRILIA.jpg",
	"./ARCTIC CAT.jpg": "./assets/images/vehicle/makes/ARCTIC CAT.jpg",
	"./AUDI.jpg": "./assets/images/vehicle/makes/AUDI.jpg",
	"./BENTLEY.jpg": "./assets/images/vehicle/makes/BENTLEY.jpg",
	"./BMW.jpg": "./assets/images/vehicle/makes/BMW.jpg",
	"./BUGATTI.jpg": "./assets/images/vehicle/makes/BUGATTI.jpg",
	"./CANAM.jpg": "./assets/images/vehicle/makes/CANAM.jpg",
	"./CHEVROLET.jpg": "./assets/images/vehicle/makes/CHEVROLET.jpg",
	"./CITROEN.jpg": "./assets/images/vehicle/makes/CITROEN.jpg",
	"./CORVETTE.jpg": "./assets/images/vehicle/makes/CORVETTE.jpg",
	"./DATSUN.jpg": "./assets/images/vehicle/makes/DATSUN.jpg",
	"./DODGE.jpg": "./assets/images/vehicle/makes/DODGE.jpg",
	"./DUCATI.jpg": "./assets/images/vehicle/makes/DUCATI.jpg",
	"./EPAPOWER.jpg": "./assets/images/vehicle/makes/EPAPOWER.jpg",
	"./FIA.jpg": "./assets/images/vehicle/makes/FIA.jpg",
	"./FIAT.jpg": "./assets/images/vehicle/makes/FIAT.jpg",
	"./FORD.jpg": "./assets/images/vehicle/makes/FORD.jpg",
	"./GTR.jpg": "./assets/images/vehicle/makes/GTR.jpg",
	"./HARLEY.jpg": "./assets/images/vehicle/makes/HARLEY.jpg",
	"./HOLDEN.jpg": "./assets/images/vehicle/makes/HOLDEN.jpg",
	"./HONDA.jpg": "./assets/images/vehicle/makes/HONDA.jpg",
	"./HYDROSPACE.jpg": "./assets/images/vehicle/makes/HYDROSPACE.jpg",
	"./HYUNDAI.jpg": "./assets/images/vehicle/makes/HYUNDAI.jpg",
	"./INFINITI.jpg": "./assets/images/vehicle/makes/INFINITI.jpg",
	"./JAGUAR.jpg": "./assets/images/vehicle/makes/JAGUAR.jpg",
	"./JEEP.jpg": "./assets/images/vehicle/makes/JEEP.jpg",
	"./JRR.jpg": "./assets/images/vehicle/makes/JRR.jpg",
	"./KAWASAKI.jpg": "./assets/images/vehicle/makes/KAWASAKI.jpg",
	"./KIA.jpg": "./assets/images/vehicle/makes/KIA.jpg",
	"./LAMBORGHINI.jpg": "./assets/images/vehicle/makes/LAMBORGHINI.jpg",
	"./LEXUS.jpg": "./assets/images/vehicle/makes/LEXUS.jpg",
	"./LINKCO.jpg": "./assets/images/vehicle/makes/LINKCO.jpg",
	"./LOTUS.jpg": "./assets/images/vehicle/makes/LOTUS.jpg",
	"./MASERATI.jpg": "./assets/images/vehicle/makes/MASERATI.jpg",
	"./MAZDA.jpg": "./assets/images/vehicle/makes/MAZDA.jpg",
	"./MCLAREN.jpg": "./assets/images/vehicle/makes/MCLAREN.jpg",
	"./MERCEDES AMG.jpg": "./assets/images/vehicle/makes/MERCEDES AMG.jpg",
	"./MERCEDES.jpg": "./assets/images/vehicle/makes/MERCEDES.jpg",
	"./MERCURY RACING.jpg": "./assets/images/vehicle/makes/MERCURY RACING.jpg",
	"./MINI.jpg": "./assets/images/vehicle/makes/MINI.jpg",
	"./MITSUBISHI.jpg": "./assets/images/vehicle/makes/MITSUBISHI.jpg",
	"./MUSTANG.jpg": "./assets/images/vehicle/makes/MUSTANG.jpg",
	"./NISSAN.jpg": "./assets/images/vehicle/makes/NISSAN.jpg",
	"./OFFROAD.jpg": "./assets/images/vehicle/makes/OFFROAD.jpg",
	"./PEUGEOT.jpg": "./assets/images/vehicle/makes/PEUGEOT.jpg",
	"./POLARIS.jpg": "./assets/images/vehicle/makes/POLARIS.jpg",
	"./PORSCHE.jpg": "./assets/images/vehicle/makes/PORSCHE.jpg",
	"./PROTON.jpg": "./assets/images/vehicle/makes/PROTON.jpg",
	"./RALLYCROSS.jpg": "./assets/images/vehicle/makes/RALLYCROSS.jpg",
	"./RENAULT.jpg": "./assets/images/vehicle/makes/RENAULT.jpg",
	"./SALASKO RACING.jpg": "./assets/images/vehicle/makes/SALASKO RACING.jpg",
	"./SCION.jpg": "./assets/images/vehicle/makes/SCION.jpg",
	"./SEADOO.jpg": "./assets/images/vehicle/makes/SEADOO.jpg",
	"./SEAT.jpg": "./assets/images/vehicle/makes/SEAT.jpg",
	"./SKIDOO.jpg": "./assets/images/vehicle/makes/SKIDOO.jpg",
	"./SKODA.jpg": "./assets/images/vehicle/makes/SKODA.jpg",
	"./SUBARU.jpg": "./assets/images/vehicle/makes/SUBARU.jpg",
	"./SUZUKI.jpg": "./assets/images/vehicle/makes/SUZUKI.jpg",
	"./SWITZER DYNAMICS.jpg": "./assets/images/vehicle/makes/SWITZER DYNAMICS.jpg",
	"./TOYOTA.jpg": "./assets/images/vehicle/makes/TOYOTA.jpg",
	"./TOYOTASUBARU.jpg": "./assets/images/vehicle/makes/TOYOTASUBARU.jpg",
	"./TRIUMPH.jpg": "./assets/images/vehicle/makes/TRIUMPH.jpg",
	"./V8SUPERCARS.jpg": "./assets/images/vehicle/makes/V8SUPERCARS.jpg",
	"./VOLVO.jpg": "./assets/images/vehicle/makes/VOLVO.jpg",
	"./VW.jpg": "./assets/images/vehicle/makes/VW.jpg",
	"./YAMAHA.jpg": "./assets/images/vehicle/makes/YAMAHA.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/images/vehicle/makes sync recursive ^\\.\\/.*\\.jpg$";